/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewProductSuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore }: TypeProps = this.props;
    const parentForm: Object = this.props.parentForm;
    const model: Object = this.props.model;
    const manufacturerModel: Object = this.props.manufacturerModel;

    //Set Selected Trading Account
    parentForm.$('chooseAccount.tradingAccount').extra.selectID =
      actionDrawerStore.response.account_id;

    //Set Selected Manufacturer
    parentForm
      .$('assetDetail.manufacturer')
      .set('value', actionDrawerStore.response.manufacturer.id);
    const fieldManufacturer: Object = parentForm.$('assetDetail.manufacturer');
    const fieldManufacturerExtra: Object = fieldManufacturer.extra;

    fieldManufacturer.set('value', actionDrawerStore.response.manufacturer.name);
    fieldManufacturer.set('extra', {
      ...fieldManufacturerExtra,
      selectID: actionDrawerStore.response.manufacturer.id,
    });
    // manufacturerModel.filterId = actionDrawerStore.response.manufacturer.id;
    // manufacturerModel.parentId = actionDrawerStore.response.manufacturer.id;
    manufacturerModel.search = '';
    manufacturerModel.loadData();

    //Set Selected Model Description
    parentForm.$('assetDetail.modelDescription').value =
      actionDrawerStore.response.product_group_description;

    //product
    const field: Object = parentForm.$('assetDetail.model');
    const fieldExtra: Object = field.extra;

    field.set('value', actionDrawerStore.response.name);
    field.set('extra', { ...fieldExtra, selectID: actionDrawerStore.response.id });
    model.filterId = `${actionDrawerStore.response.manufacturer.id}?account_id=${
      actionDrawerStore.response.account_id
    }`;
    model.parentId = `${actionDrawerStore.response.manufacturer.id}?account_id=${
      actionDrawerStore.response.account_id
    }`;
    model.loadData();

    actionDrawerStore.closeActionDrawer();
  }

  render(): React.Element<*> {
    return 'success';
  }
}
